import apiSlice from "./ApiSlice";

const BatchTypeApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // get all delivery dates
    getAllBatchTypeData: builder.query({
      providesTags: ["batch-type"],
      query: (body: PaginationPayloadType) => {
        return {
          url: "/batch-type",
          method: "POST",
          body,
        };
      },
    }),

    // delete delivery date
    deleteBatchTypeById: builder.mutation({
      invalidatesTags: ["batch-type"],
      query: (id: any) => ({
        url: `/batch-type/${id}`,
        method: "DELETE",
      }),
    }),
    // add delivery date
    addBatchType: builder.mutation({
      invalidatesTags: ["batch-type"],
      query: (body) => ({
        url: `/batch-type/add`,
        method: "POST",
        body,
      }),
    }),
    //get delivery date by Id
    getBatchTypeById: builder.query({
      providesTags: ["batch-type"],
      query: (id: string) => {
        return {
          url: `/batch-type/${id}`,
          method: "GET",
        };
      },
    }),

    // update delivery date
    updateBatchTypeById: builder.mutation({
      invalidatesTags: ["batch-type"],
      query: ({ body, id }) => ({
        url: `/batch-type/${id}`,
        method: "PUT",
        body,
      }),
    }),

    //get AllBatchTypes
    getAllBatchTypes: builder.query({
      providesTags: ["batch-type"],
      query: () => {
        return {
          url: `/batch-type`,
          method: "GET",
        };
      },
    }),

      
    // change status of delivery date
    changeStatusBatchTypeById: builder.mutation({
      invalidatesTags: ["batch-type"],
      query: ({ body, id }) => ({
        url: `/batch-type/status-change/${id}`,
        method: "PUT",
        body,
      }),
    }),
  }),
});

export const {
  useGetAllBatchTypeDataQuery,
  useDeleteBatchTypeByIdMutation,
  useAddBatchTypeMutation,
  useGetBatchTypeByIdQuery,
  useGetAllBatchTypesQuery,
  useUpdateBatchTypeByIdMutation,
  useChangeStatusBatchTypeByIdMutation,
} = BatchTypeApi;
